// External libraries
// Internal modules
import { getGlobals } from '../globals';
import { logger } from '../logger';
import { isFunction } from '@/lib/utils/typeUtils';

export const browserFeatureDetection = {
  paymentRequestApi(): void {
    const { device } = getGlobals();

    if (!isFunction(window.PaymentRequest)) {
      logger.info('payment_request_api_unavailable', device);
      return;
    }

    try {
      // Dummy transaction amount. We don't need to send the actual data
      // to make the call to `.canMakePayment()`
      const total = {
        amount: {
          currency: 'USD',
          value: '0.00',
        },
        label: 'Total',
      };
      const supportedMethods = 'basic-card';
      const request = new PaymentRequest([{ supportedMethods }], { total });

      request
        .canMakePayment()
        .then(canMakePayment => {
          logger.info('payment_request_api_available', {
            canMakePayment,
            ...device,
          });
        })
        .catch(error => {
          logger.info('payment_request_api_can_make_payment_error', {
            error,
            ...device,
          });
        });
    } catch (error) {
      logger.info('payment_request_api_error', { error, ...device });
    }
  },
};
